import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TaskService} from '../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'nf-field-condition',
  templateUrl: './field-condition.component.html',
  styleUrls: ['./field-condition.component.css']
})
export class FieldConditionComponent implements OnInit {
  conditionDisplayText = '条件';
  conditions = [];
  filterConditions = [];
  conditionColumns = [];
  conditionOpe1 = [
    {title: '等于', operator: 'is'},
    {title: '不等于', operator: 'is_not'}
  ];
  conditionOpe2 = [
    {title: '等于', operator: 'is'},
    {title: '不等于', operator: 'is_not'},
    {title: '包含', operator: 'includes'},
    {title: '不包含', operator: 'not_includes'}
  ];
  conditionOpe3 = [
    {title: '不早于', operator: 'not_less_than'}
  ];
  automation: any;
  indicatorOption = [];
  supervisoryId: string;
  @Input('nfData') set setNfData(data: any) {
    if (data) {
      this.filterConditions = data;
    }
  }
  @Input() set optionsData(data: any) {
    if (data) {
    }
  }
  @Input('automation') set automationChange(data: any) {
    if (data) {
      this.automation = data;
      this.filterConditions = this.automation.conditions || [];
    }
  }
  @Input('supervisoryId') set supervisoryIdChange(id: string) {
    this.supervisoryId = id;
    this.getIndicatorRulesData();
  }
  @Input('column') set setColumn(column: any) {
    if (column && column.length > 0) {
      for (const col of column) {
        if (col.type === 'status') {
          this.conditionColumns.push(col);
        } else if (col.type === 'taskProgress') {
          this.conditionColumns.push(col);
        }
        if (col.type === 'name' || col.type === 'date' || col.type === 'text') {
          this.conditionColumns.push(col);
        }
      }
    }
  }
  @Input('source') set sourceChagne(source: string) {
    switch (source) {
      case 'indicator':
        const indicatorItem = {
          title: '监控条件',
          type: 'indicator',
          source: 'indicator',
          id: this.randomString(12)
        };
        this.conditionColumns.push(indicatorItem);
        break;
      case 'dateCondition':
        const workflowItem = {
          title: '日期条件',
          type: 'dateCondition',
          source: 'dateCondition',
          id: this.randomString(12)
        };
        this.conditionColumns.push(workflowItem);
        break;
      default:
        break;
    }
  }
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private datePipe: DatePipe,
    private message: NzMessageService,
    private taskService: TaskService,
  ) { }

  ngOnInit(): void {
  }
// 处理主题选项更改事件
  handleFilterConditionSelectChange(column, condition) {
    condition.title = column.title;
    condition.field = column.id;
    condition.type = column.type;
    condition.value = null;
    switch (column.type) {
      case 'name':
        condition['operators'] = this.conditionOpe2;
        break;
      case 'text':
        condition['operators'] = this.conditionOpe2;
        break;
      case 'status':
        condition['operators'] = this.conditionOpe1;
        condition['valueConfig'] = column.labels;
        break;
      case 'taskProgress':
        condition['operators'] = this.conditionOpe1;
        condition['valueConfig'] = column.labels;
        break;
      case 'date':
        condition['operators'] = this.conditionOpe1;
        break;
      case 'dateCondition':
        condition['operators'] = this.conditionOpe3;
        condition['value'] = {
          time: null,
          days: null
        };
        break;
      case 'indicator':
        if (this.supervisoryId) {
          condition['operators'] = this.conditionOpe1;
        } else {
         this.message.create('info', '请先选择监控项！');
        }
        break;
    }
    condition['operator']['title'] = condition['operators'][0]['title'];
    condition['operator']['operator'] = condition['operators'][0]['operator'];
    condition['visible'] = false;
  }
  // 处理操作符选项变更
  handleConditionOperatorChange(condition, operator) {
    condition['operator']['title'] = operator['title'];
    condition['operator']['operator'] = operator['operator'];
    condition['operatorVisible'] = false;
  }
  // 日期变更
  dateChange(condition) {
    if (condition['value']) {
      condition['value'] = this.datePipe.transform(condition['value'], 'yyyy-MM-dd');
    }
  }
  // 处理筛选值变更
  handleConditionValueChange(condition, option) {
    condition['value'] = option['index'];
    condition['valueText'] = option['label'];
    condition['valueVisible'] = false;
  }
  // 删除筛选条件
  deleteFilterCondition(index: number) {
    this.filterConditions.splice(index, 1);
    console.log(this.filterConditions)
    this.nfDataChange.emit(this.filterConditions);
  }
  // 添加筛选条件
  addFilterCondition() {
    this.filterConditions.push({
      title: null,
      field: null,
      type: null,
      value: null,
      valueText: null,
      operators: [],
      operator: {
        title: null,
        operator: null
      }
    });
    this.nfDataChange.emit(this.filterConditions);
  }
  randomString(length) {
    const str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = length; i > 0; --i) {
      result += str[Math.floor(Math.random() * str.length)];
      return result;
    }
  }
  getIndicatorRulesData() {
    const params = {
      itemId: this.supervisoryId
    };
    this.taskService.getIndicatorRules(params).subscribe((res: any) => {
      this.indicatorOption = res && res._embedded ? res._embedded.vos : [];
    });
  }
  onDateChange(condition) {
    if (condition['value'] && condition['value'].time) {
      condition['value'].time = this.datePipe.transform(condition['value'].time, 'HH:mm');
    }
  }
}
